import React from 'react';

import { MigrationStepConfirm } from '../../../common/migration/MigrationStepConfirm';

const i18n = {
    confirmTitle: 'CLIENT_ORGANIZATION_MIGRATION_CONFIRM_TITLE',
    sourceRegion: 'CLIENT_ORGANIZATION_MIGRATION_SOURCE_REGION',
    destinationRegion: 'CLIENT_ORGANIZATION_MIGRATION_DESTINATION_REGION',
    downtimeWindow: 'CLIENT_ORGANIZATION_MIGRATION_DOWNTIME_WINDOW',
    dateWindow: 'CLIENT_ORGANIZATION_MIGRATION_DATE_WINDOW',
    whatsNext: 'CLIENT_ORGANIZATION_MIGRATION_WHATS_NEXT',
    confirmInfoKey: (n: number) => `CLIENT_ORGANIZATION_MIGRATION_CONFIRM_INFO_${n}`,
} as const;

export const OrgMigrationStepConfirm: React.FC = () => (
    <MigrationStepConfirm
        fixedWidth="200px"
        i18n={i18n}
    />
);
